import request from '@/utils/request'

export function fetchList(params) {
    return request({
        url: '/article/recommends.json',
        method: 'get',
        headers: {
            'Content-Type':'application/x-www-form-urlencoded;charset=utf-8'
            },
        params: params
    })
}

export function fetchFocus(params) {
    return request({
        url: '/article/focus.json',
        method: 'get',
        headers: {
            'Content-Type':'application/x-www-form-urlencoded;charset=utf-8'
            },
        params: params
    })
}
/*export function fetchList(params) {
    return request({
        url: '/post/list',
        method: 'get',
        params: params
    })
}

export function fetchFocus() {
    return request({
        url: '/focus/list',
        method: 'get',
        params: {}
    })
}*/
// export function fetchCategory() {
//     return request({
//         url: '/category',
//         method: 'get',
//         params: {}
//     })
// }
export function fetchCategory() {
    return request({
        url: '/category/list.json',
        method: 'get',
        params: {}
    })
}

export function fetchFriend() {
    return request({
        url: '/friend',
        method: 'get',
        params: {}
    })
}

export function fetchSocial() {
    return request({
        url: '/social',
        method: 'get',
        params: {}
    });
}

export function fetchSiteInfo() {
    return request({
        url: '/site',
        method: 'get',
        params: {}
    })
}

export function fetchComment() {
    return request({
        url: '/comment',
        method: 'get',
        params: {}
    })
}
export function fetchArticles(res) {
    return request({
        url: '/article/'+res+'/show.json',
        method: 'get',
        params: {}
    })
}
